import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"
// import ProtectedRoute from './components/ProtectedRoute';
// import { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css"
// import SideBar from "./components/SideBar";
import LoginPage from './pages/login';
// import Home from './pages/home';
// import Dashboard from "./pages/Dashboard";
// import Checker from "./pages/Checker";
// import Messages from "./pages/Messages";
// import Settings from "./pages/Settings";
// import Master from "./pages/Master";
// import MasterChecker from "./pages/MasterChecker";
// import OperatorChecker from "./pages/OperatorChecker";
// import ValidationRulesChecker from "./pages/ValidationRulesChecker";
// import RDMupload from './pages/RDMupload';
// import Operators from './pages/Operators';
// import ValidationRules from './pages/ValidationRules';
// import FunctionsStack from './pages/FunctionsStack';
// import TableDetails from './pages/Tabledetails';
// import Jsontable from './pages/Jsontable';
// import OperaterJsontable from './pages/OperaterJsontable';
// import MasterTableDetails from './pages/MasterTabledetails';
// import OperatorTableDetails from './pages/OperatorTabledetails';
// import ValidationRulesTableDetails from './pages/ValidationRulesTabledetails';
// import Masterupload from './pages/Masterupload';
// import Reviewtable from './pages/Reviewtable';
// import Demadmin from './pages/Demadmin';
// import DEMupload from './pages/DEMupload';
// import BDMAdminUpload from './pages/BDMAdminUpload';
// import DemAdminTabledetails from './pages/DemAdminTabledetails';
// import DemRetrieve from './pages/DemRetrieve';
// import Templateform from './pages/TemplateForm';
// import Templateformlist from './pages/Templateformlist';
// import Edittemplateform from './pages/EditTemplateForm';
// import Templateformmodifylist from './pages/Templateformmodifylist';
// import Templatetablelist from './pages/Templatetablelist';
// import DEMcheckertablelist from './pages/DEMcheckertablelist';
// import DEMchecker from './pages/DEMchecker';
// import DEMcheckertable from './pages/DEMcheckertable';
// import MasterRDM from './pages/RDMMasterTabledetails';
// import OperatorsRDM from './pages/RDMOperatorTabledetails';
// import ValidationRulesRDM from './pages/RDMValidationrulesTabledetails';
// import FunctionsStackRDM from './pages/RDMFunctionsStackTabledetails';
// import DemAdminRetrieve from './pages/DemAdminRetrieve';
// import DemcheckerRTL from './pages/DemcheckerRTL';
// import Demcheckertemplate from './pages/Demcheckertemplate';
// import MastercheckerRDM from './pages/RDMMastercheckerTabledetails';
// import OperatorcheckerRDM from './pages/RDMOperatorcheckerTabledetails';
// import ValidationRulesCheckerRDM from './pages/RDMValidationrulescheckerTabledetails';
// import Bdmadmin from './pages/Bdmadmin';
// import BDMupload from './pages/BDMupload';
// import BdmAdminTabledetails from './pages/BdmAdminTabledetails';
// import BdmAdminRetrieve from './pages/BdmAdminRetrieve';
// import DemRetrieveTabledetails from './pages/DemRetrieveTabledetails';
// import BdmRetrieve from './pages/BdmRetrieve';
// import BdmRetrieveTabledetails from './pages/BdmRetrieveTabledetails';
// import BDMchecker from './pages/BDMchecker';
// import BdmcheckerRTL from './pages/BdmcheckerRTL';
// import Bdmcheckertemplate from './pages/Bdmcheckertemplate';
// import BdmcheckerTable from './pages/BdmcheckerTable';
// import BDMcheckertablelist from './pages/BDMcheckertablelist';
// import Bulkupload from './pages/Bulkupload';
// import BDMuploadTabledetails from './pages/BDMuploadTabledetails';
// import Mastermodify from './pages/Mastermodify';
// import MastermodifyRDM from './pages/RDMMastermodifyTabledetails';
// import MasterModifyTableDetail from './pages/MasterModifyTableDetail';
// import BdmPreview from './pages/BdmPreview';
// import DemPreview from './pages/DemPreview';
// import Bulkmodify from './pages/Bulkmodify';
// import BulkmodifyBDM from './pages/BDMMakermodifyTabledetails';
// import BulkModifyTableDetail from './pages/BulkModifyTableDetail';
// import AccessUser from './pages/Users';
// import AccessHierarchy from './pages/Hierarchy';
// import RDMmasterbkp from './pages/RDMTablebkp';
// import DEMBDMTemplatebkp from './pages/DEMBDMTemplatebkp';
// import RDMbkptablelist from './pages/RDMbkptablelist';
// import DEMModifytemplate from './pages/DEMModifytemplate';
// import DemAdminTemplatModify from './pages/DemAdminTemplatModify';
// import DemTemplatePreview from './pages/DemTemplatePreview';
// import DemCheckerRetrieve from './pages/DemCheckerRetrieve';
// import DemRetrievecheckerTabledetails from './pages/DemRetrievecheckerTabledetails';
// import DemRetrievechecker from './pages/DemRetrievechecker';
// import BackupList from './pages/BackupList';
// import DemMakerRetrieve from './pages/DemMakerRetrieve';
// import DemRetrievemakerTabledetails from './pages/DemRetrievemakerTabledetails';
// import DemMakerRetrieveModifyTableDetail from './pages/DemMakerRetrieveModifyTableDetail';
// import DEMModifyupload from './pages/DEMModifyupload';
// import DemRetrievecheckermodifyTabledetails from './pages/DemRetrievecheckermodifyTabledetails';
// import DEMRetrieveCheckermodify from './pages/DEMRetrieveCheckermodify';
// import RDMAdminRetrieve from './pages/RDMAdminRetrieve';
// import RDMRetrieveTabledetails from './pages/RDMRetrieveTabledetails';
// import RDMRetrieve from './pages/RDMRetrieve';
// import RDMCheckerRetrieve from './pages/RDMCheckerRetrieve';
// import RDMRetrievecheckermodifyTabledetails from './pages/RDMRetrievecheckermodifyTabledetails';
// import RDMRetrievecheckerTabledetails from './pages/RDMRetrievecheckerTabledetails';
// import ForgotPassword from './pages/ForgotPassword';
// import RDMRetrievechecker from './pages/RDMRetrievechecker';
// import RDMRetrieveCheckermodify from './pages/RDMRetrieveCheckermodify';
// import RDMRetrievemodifyTabledetails from './pages/RDMRetrievemodifyTabledetails';
// import RDMchangeRetrieveModifyTableDetail from './pages/RDMchangeRetrieveModifyTableDetail';
// import BDMRetrievechecker from './pages/BDMRetrievechecker';
// import BDMRetrievecheckerTabledetails from './pages/BDMRetrievecheckerTabledetails';
// import BDMRetrieveCheckermodify from './pages/BDMRetrieveCheckermodify';
// import BDMRetrievecheckermodifyTabledetails from './pages/BDMRetrievecheckermodifyTabledetails';
// import BDMCheckerRetrieve from './pages/BDMCheckerRetrieve';
// import BDMMakerRetrieveModifyTableDetail from './pages/BDMMakerRetrieveModifyTableDetail';
// import BDMRetrievemakerTabledetails from './pages/BDMRetrievemakerTabledetails';
// import BDMMakerRetrieve from './pages/BDMMakerRetrieve';
// import ResetPassword from './pages/ResetPassword';
// import LinkResetPassword from './pages/LinkResetPassword';
// import UserManagement from './pages/UserManagement';
// import AccessControls from './pages/AccessControls';
// import Mastermaker from "./pages/Mastermaker";
// import MastermakerRDM from "./pages/MastermakerRDM";
// import Operatorsmaker from "./pages/Operatorsmaker";
// import OperatorsmakerRDM from "./pages/OperatorsmakerRDM";
// import FunctionsStackmaker from "./pages/FunctionsStackmaker";
// import FunctionsStackmakerRDM from "./pages/FunctionsStackmakerRDM";
// import DEMUploadModifyTemplate from "./pages/DEMUploadModifyTemplate";
// import Datalevel from "./pages/Datalevel";
// import Auditlevel from "./pages/Auditlevel";
// import Datalevelchecker from "./pages/Datalevelchecker";
// import Datalevelchecker_test from "./pages/Datalevelchecker_test";
// import BackupPreview from "./pages/BackupPreview";
// import BdmMakerPreview from "./pages/BdmMakerPreview";
// import RDMmastercheckerbkp from "./pages/RDMmastercheckerbkp";
// import RDMbkpcheckertablelist from "./pages/RDMbkpcheckertablelist";
// import BackupcheckerList from "./pages/BackupcheckerList";
// import BackupcheckerPreview from "./pages/BackupcheckerPreview";
// import DEMbkptablelist from "./pages/DEMbkptablelist";
// import BDMbkptablelist from "./pages/BDMbkptablelist";
// import DEMBDMtempcheckerbkp from "./pages/DEMBDMtempcheckerbkp";
// import DEMbkpcheckertablelist from "./pages/DEMbkpcheckertablelist";
// import BDMbkpcheckertablelist from "./pages/BDMbkpcheckertablelist";
// import DEMBackupcheckerList from "./pages/DEMBackupcheckerList";
// import BDMBackupcheckerList from "./pages/BDMBackupcheckerList";
// import DEMBackupcheckerPreview from "./pages/DEMBackupcheckerPreview";
// import BDMBackupcheckerPreview from "./pages/BDMBackupcheckerPreview";
// import DemuploadAdmin from "./pages/DemuploadAdmin";
// import AdminautoDEM from "./pages/AdminautoDEM";
// import DEMautoTableDetails from "./pages/DEMautoTableDetails";
// import BDMModifytemplate from './pages/BDMModifytemplate';
// import BdmAdminTemplatModify from './pages/BdmAdminTemplatModify';
// import BDMUploadModifyTemplate from "./pages/BDMUploadModifyTemplate";
// import BdmuploadautoAdmin from "./pages/BdmuploadautoAdmin";
// import AdminautoBDM from "./pages/AdminautoBDM";
// import BDMautoTableDetails from "./pages/BDMautoTableDetails";
// import DEMBackupList from "./pages/DEMBackupList";
// import BDMBackupList from "./pages/BDMBackupList";
// import BDMBackupPreview from "./pages/BDMBackupPreview";
// import DEMBackupPreview from "./pages/DEMBackupPreview";
// import TemplateHierarchy from "./pages/TemplateHierarchy";
// import DataHierarchy from "./pages/DataHierarchy";
// import QuickEntryOcr from "./pages/QuickEntryOcr";
// import TemplateformlistOcrUpload from "./pages/TemplateformlistOcrUpload";
// import BulkupdateRetrieve from "./pages/BulkupdateRetrieve";
// import DEMRetrieveModifytabledata from "./pages/DEMRetrieveModifytabledata";
// import BDMRetrieveModifytabledata from "./pages/BDMRetrieveModifytabledata";
// import Dashboardreport from "./pages/Dashboardreport";
// import Comaprisontablelist from "./pages/Comaprisontablelist";

// import Form from "./pages/Form";
// import Modify from "./pages/Modify";

// import DemAdminRejectedTemplatModify from "./pages/DemAdminRejectedTemplatModify";
// import DEMUploadModifyRejectedTemplate from "./pages/DEMUploadModifyRejectedTemplate";

// import BdmAdminRejectedTemplatModify from "./pages/BdmAdminRejectedTemplatModify";
// import BDMUploadRejectedModifyTemplate from "./pages/BDMUploadRejectedModifyTemplate";

// import FunctionsStackchecker from "./pages/FunctionsStackchecker";
// import FunctionsStackcheckerRDM from "./pages/FunctionsStackcheckerRDM";


// import Datalevelcheckerrept from "./pages/Datalevelcheckerrept";
// import DataControls from "./pages/DataControls";

import RejectedReason from "./components/RejectedReason";
import Chatbot from "./components/Chatbot";
import { Pagination } from 'react-bootstrap';
// import Paginate from "./components/Paginate";
// import BDMDesignTemplate from "./pages/BDMDesignTemplate";
// import BDMDesignRejectedTemplateModify from "./pages/BDMDesignRejectedTemplateModify";
// import BDMDesignTableDetails from "./pages/BDMDesignTableDetails";
// import DataTemplateControl from "./pages/DataTemplateControl";
// import DEMDesignTableDetails from "./pages/DEMDesignTableDetails";
// import DEMDesignExistingTableDetails from "./pages/DEMDesignExistingTableDetails";
// import BDMDesignExistingTableDetails from "./pages/BDMDesignExistingTableDetails";
// import DEMDesignTemplate from "./pages/DEMDesignTemplate";
// import DEMDesignRejectedTemplateModify from "./pages/DEMDesignRejectedTemplateModify";
// import Rdmcheckertablelist from "./pages/Rdmcheckertablelist";
import Modalpopup from "./components/Modalpopup";
// import OCRMethod from "./pages/OCRMethod";
// import UserManagementTempupload from './pages/UserManagementTempupload';
// import UserManagementTempBDMupload from './pages/UserManagementTempBDMupload';
// import BDMOcrupload from './pages/BDMOcrupload';
// import PreviewBDM from "./pages/PreviewBDM";
import Preview from "./pages/Preview";
// import FAQ from "./pages/FAQ";
// import Bulkupdate from "./pages/Bulkupdate";
// import BulkOcrUpdate from "./pages/BulkOcrUpdate";
// import EditRetrievalForm from "./pages/EditRetrievalForm";
// import AuditReport from "./pages/AuditReport";
// import BulkuploadOcrTabledetails from './pages/BulkuploadOcrTabledetails';
import { ChatbotProvider } from "./components/ChatbotContext";
// import AuditReportDetails from "./pages/AuditReportDetails";
// import AuditUserReportDetails from "./pages/AuditUserReportDetails";
// import DEMcheckerRetrievetablelist from "./pages/DEMcheckerRetrievetablelist";
// import DEMcheckerRetrievetable from "./pages/DEMcheckerRetrievetable";
// import EditModifyRetrievalForm from "./pages/EditModifyRetrievalForm";
// import BulkupdateModifyRetrieve from "./pages/BulkupdateModifyRetrieve";
// import ReportDesign from "./pages/ReportDesign";
import TemplateUpload from "./pages/TemplateUpload";
// import blobWorker from "./components/blobWorker";
// import Datalevelcomparison from "./pages/Datalevelcomparison";
// import Datalevelcomparison1 from "./pages/Datalevelcomparison1";
// import DashboardAuditTableDetails from "./pages/DashboardAuditTableDetails";
// import DashboardAuditMakerActivityDetails from "./pages/DashboardAuditMakerActivityDetails";

// New Page Imports
import { Modal, Button, Row, Col, Container, InputGroup } from 'react-bootstrap';
import { BsPerson, BsLock, BsEye, BsEyeSlash } from 'react-icons/bs';
// import GapsyLogin from './pages/gapsy-login';
import GapsyAdashboard from './pages/gapsy-Adashboard';
import GapsyCdashboard from './pages/gapsy-Cdashboard';
import GapsyMdashboard from './pages/gapsy-Mdashboard';
import GapsyFbc from './pages/gapsy-fbc';
import GapsyIbm from './pages/gapsy-ibm';
import GapsyIbmCreate from './pages/gapsy-ibmCreate';
import GapsyMet from './pages/gapsy-Met';
import GapsyTempAssign from './pages/gapsy-Tassign';
import GapsyReAssign from './pages/gapsy-ReAssign';
import GapsyQem from './pages/gapsy-Mqem';
import GapsyQeRejectData from './pages/gapsy-QE-RejectData';
import GapsyEditTemplateForm from './pages/gapsy-EditTemplateForm';
import GapsyEditPastData from './pages/gapsy-Editpastdata';
import GapsyModifyPastData from './pages/gapsy-Modifypastdata';
import GapsyReport from './pages/gapsyreport';
import GapsyFooter from './pages/gapsy-footer';

import GapsyDashboardReport from "./pages/GapsyDashboardReport";


import GapsyUserRegistration from './pages/gapsy-userRegistration';
import GapsyUserMapping from './pages/gapsy-userMapping';
import GapsyUserConfig from './pages/gapsy-userConfig';
import GapsyUserModify from './pages/gapsy-userModify';
import GapsyUserRoleandMapping from './pages/gapsy-userRoleandMapping.js';
import GapsyParameterMapping from './pages/gapsy-parameterMapping.js';
import GapsyAutomatedUpload from './pages/gapsy-automatedUpload';

// import GapsySamplePage from './pages/gapsy-referempty';

// import GapsyHome from './pages/gapsy-dashboard';
// import GapsyDashobardAdmin from './pages/gapsy-dashboardAdmin';
// gapsy for the dashbaord admin and IT chart
// import GapsyDashobardAdmin1 from './pages/gapsy-dashboardAdmin1';
// import GapsyadminDashboardchart from './pages/GapsyadminDashboardchart';
// import Gapsyheader from "./components/Gapsyheader";
// import GapsyMakerDashboardchart from './pages/GapsyMakerDashboardchart';

// vasanth urls
import GapsyBDMupload from './pages/GapsyBDMupload';
import SummaryReport from './pages/SummaryReport';
import GapsyModifyupload from './pages/GapsyModifyupload';
// import GapsyTablelist from "./pages/GapsyTablelist";
// import GapsyCheckerDashboardchart from './pages/GapsyCheckerDashboardchart';
import Dropdown from './components/Dropdown';
import PopupTableModal from "./components/PopupTableModal";
import ProtectedRoute from "./components/ProtectedRoute";


import GapsyRData from './pages/gapsyrdata';
import GapsyCaudit from './pages/gapsycaudit';
import NotFound from './pages/NotFound';
import GapsyQeApproveData from "./pages/gapsy-QE-ApproveData";
import GapsyTrendreport from './pages/gapsytrendreport';
import { SessionProvider } from "./components/SessionContext";
import GapsyRiskAppetiteReport from './pages/GapsyRiskAppetiteReport';
import GapsyCRODashboard from './pages/GapsyCRODashboard';
import GapsyTableauReport from './pages/GapsyTableauReport';
import Sidebar from "./components/sidebar";
import GapsyShariah from './pages/gapsyShariah';
import GapsyResidualCreditRisk from './pages/gapsyResidualCreditRisk';
import GapsyResidualModifyRisk from './pages/gapsyResidualModifyRisk';
import GapsyShariahModify from './pages/gapsyShariahModify';
import GapsyShariah1 from './pages/GapsyShariahRajni';
import GapsyShariahList from './pages/GapsyShariahList';
import GapsyResidualCreditRiskList from './pages/GapsyResidualCreditRiskList';
import GapsyShariahListReview from './pages/GapsyShariahListReview';
import GapsyShariahListReinstate from './pages/GapsyShariahListReinstate';
import GapsyResidualReinstateList from './pages/gapsyResidualReinstateList';
// import GapsyShariahListPast from './pages/GapsyShariahListPast';
import GapsyShariahReview from './pages/gapsyShariahReview';
import GapsyShariahReport from './pages/GapsyShariahReport';
import GapsyShariahAdmin from './pages/GapsyShariahAdmin';
import GapsyShariahModifyRetrieval from './pages/gapsyShariahModifyRetrieval';
import GapsyShariahPastApprove from './pages/gapsyShariahPastApprove';
import GapsyShariahReinstate from './pages/gapsyShariahReinstate';
import GapsyResidualReinstate from './pages/gapsyResidualReinstate';
import GapsyShariahOverride from './pages/gapsyShariahOverride';
import GapsyShariahOverrideList from './pages/GapsyShariahOverrideList';
import GapsyShariahPastRetrieval from './pages/gapsyShariahPastRetrieval';
import GapsyShariahReviewRetrieval from './pages/gapsyShariahReviewRetrieval';
import GapsyShariahConfiguration from './pages/GapsyShariahConfiguration';
import GapsyShariahConfig from './pages/GapsyShariahConfig';
import GapsyResidualConfig from './pages/GapsyResidualConfig';
import GapsyResidualListConfig from './pages/GapsyResidualListConfig';
import GapsyResidualListReview from './pages/gapsyResidualListReview';
import GapsyResidualReview from './pages/gapsyResidualReview';
import GapsyResidualModify from './pages/gapsyResidualModify';
import GapsyComplaint from './pages/GapsyComplaint';
import GapsyResidualOverrideList from './pages/gapsyResidualOverrideList';
import GapsyResidualOverride from './pages/GapsyResidualOverride';
import GapsyComplaintList from './pages/GapsyComplaintList';
import GapsyMakerComplaint from './pages/GapsyMakerComplaint';
import GapsyMakerComplaintsList from './pages/GapsyMakerComplaintsList';
import GapsyComplaintsReview from './pages/GapsyComplaintsReview';
import GapsyComplaintsReinstate from './pages/GapsyComplaintsReinstate';
import GapsyComplaintsListReview from './pages/GapsyComplaintsListReview';
import GapsyMakerModifyComplaint from './pages/GapsyMakerModifyComplaint';
import GapsyRetrieveModifyComplaint from './pages/GapsyRetrieveModifyComplaint';
import GapsyMedia from './pages/GapsyMedia';
import GapsyComplaintsPastApprove from './pages/gapsyComplaintsPastApprove';
import GapsyComplaintOverride from './pages/gapsyComplaintOverride';
import GapsyComplaintOverrideList from './pages/GapsyComplaintOverrideList';
import GapsyComplaintsReport from './pages/GapsyComplaintsReport';
import GapsyComplaintsConfiguration from './pages/GapsyComplaintsConfiguration';
import GapsyComplaintsConfig from './pages/GapsyComplaintsConfig';
import GapsyComplaintsWorkflowConfig from './pages/GapsyComplaintsWorkflowConfig';
import GapsyComplaintsListConfig from './pages/GapsyComplaintsListConfig';
import GapsyMakerMedia from './pages/GapsyMakerMedia';
import GapsyMakerMediaList from './pages/GapsyMakerMediaList';
import GapsyMediaListReview from './pages/GapsyMediaListReview';
import GapsyMediaReview from './pages/GapsyMediaReview';
import GapsyMakerModifyMedia from './pages/GapsyMakerModifyMedia';
import GapsyMediaList from './pages/GapsyMediaList';
import GapsyMediaReinstate from './pages/GapsyMediaReinstate';
import GapsyMediaPastApprove from './pages/gapsyMediaPastApprove';
import GapsyRetrieveModifyMedia from './pages/GapsyRetrieveModifyMedia';
import GapsyMediaOverride from './pages/GapsyMediaOverride';
import GapsyMediaOverrideList from './pages/GapsyMediaOverrideList';
import GapsyMediaReport from './pages/GapsyMediaReport';
import GapsyLeadership from './pages/GapsyLeadership';
import GapsyMakerLeadership from './pages/GapsyMakerLeadership';
import GapsyLeadershipReview from './pages/GapsyLeadershipReview';
import GapsyMakerModifyLeadership from './pages/GapsyMakerModifyLeadership';
import GapsyRetrieveModifyLeadership from './pages/GapsyRetrieveModifyLeadership';
import GapsyLeadershipOverride from './pages/GapsyLeadershipOverride';
import GapsyLeadershipPastApprove from './pages/gapsyLeadershipPastApprove';
import GapsyLeadershipListReview from './pages/GapsyLeadershipListReview';
import GapsyLeadershipReport from './pages/GapsyLeadershipReport';
import GapsyLeadershipReinstate from './pages/GapsyLeadershipReinstate';
import GapsyLeadershipOverrideList from './pages/GapsyLeadershipOverrideList';
import GapsyLeadershipList from './pages/GapsyLeadershipList';
import GapsyMakerLeadershipList from './pages/GapsyMakerLeadershipList';
import GapsyOperational from './pages/GapsyOperational';
import GapsyMakerOperational from './pages/GapsyMakerOperational';
import GapsyOperationalReview from './pages/GapsyOperationalReview';
import GapsyMakerModifyOperational from './pages/GapsyMakerModifyOperational';
import GapsyRetrieveModifyOperational from './pages/GapsyRetrieveModifyOperational';
import GapsyOperationalOverride from './pages/GapsyOperationalOverride';
import GapsyOperationalPastApprove from './pages/gapsyOperationalPastApprove';
import GapsyOperationalListReview from './pages/GapsyOperationalListReview';
import GapsyOperationalReport from './pages/GapsyOperationalReport';
import GapsyOperationalReinstate from './pages/GapsyOperationalReinstate';
import GapsyOperationalOverrideList from './pages/GapsyOperationalOverrideList';
import GapsyOperationalList from './pages/GapsyOperationalList';
import GapsyMakerOperationalList from './pages/GapsyMakerOperationalList';
import GapsyCompliance from './pages/GapsyCompliance';
import GapsyMakerCompliance from './pages/GapsyMakerCompliance';
import GapsyComplianceReview from './pages/GapsyComplianceReview';
import GapsyMakerModifyCompliance from './pages/GapsyMakerModifyCompliance';
import GapsyRetrieveModifyCompliance from './pages/GapsyRetrieveModifyCompliance';
import GapsyComplianceOverride from './pages/GapsyComplianceOverride';
import GapsyCompliancePastApprove from './pages/gapsyCompliancePastApprove';
import GapsyComplianceListReview from './pages/GapsyComplianceListReview';
import GapsyComplianceReport from './pages/GapsyComplianceReport';
import GapsyComplianceReinstate from './pages/GapsyComplianceReinstate';
import GapsyComplianceOverrideList from './pages/GapsyComplianceOverrideList';
import GapsyComplianceList from './pages/GapsyComplianceList';
import GapsyMakerComplianceList from './pages/GapsyMakerComplianceList';
import GapsyNewMapping from './pages/GapsyNewMapping';
import GapsyNewReport from './pages/GapsyNewReport';
import GapsyMakerReportList from './pages/GapsyMakerReportList';
import GapsyReportListReview from './pages/GapsyReportListReview';
import GapsyMakerReport from './pages/GapsyMakerReport';
import GapsyReportReview from './pages/GapsyReportReview';
import GapsyMakerModifyReport from './pages/GapsyMakerModifyReport';








function AppContent() {
  const location = useLocation(); // useLocation is now within BrowserRouter context
  const hideChatbot = location.pathname === "/" || location.pathname === "/ForgotPassword" || location.pathname === "/FAQ" || location.pathname === "/ResetPassword" || location.pathname === "/link-reset-password"; // Check if the current path is the login page

  return (
    <>
      {/* <ChatbotProvider> */}
      <SessionProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          {/* <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/SideBar" element={<SideBar />} />
        <Route path="/master" element={<Master />} />
        <Route path="/MasterChecker" element={<MasterChecker />} /> */}
          {/* <Route path="/GapsyDashobardAdmin1" element={<GapsyDashobardAdmin1 />} /> */}
          {/* <Route path="/GapsyadminDashboardchart" element={<GapsyadminDashboardchart />} /> 
        <Route path="/GapsyMakerDashboardchart" element={<GapsyMakerDashboardchart />} /> 
        <Route path="/GapsyCheckerDashboardchart" element={<GapsyCheckerDashboardchart />} /> 
        <Route path="/OperatorChecker" element={<OperatorChecker />} />
        <Route path="/ValidationRulesChecker" element={<ValidationRulesChecker />} />
        <Route path="/operators" element={<Operators />} />
        <Route path="/ValidationRules" element={<ValidationRules />} />
        <Route path="/FunctionsStack" element={<FunctionsStack />} />
        <Route path="/RDMupload" element={<RDMupload />} />
        <Route path="/checker" element={<Checker />} />
        <Route path="/Tabledetails" element={<TableDetails />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/Jsontable" element={<Jsontable />} />
        <Route path="/OperaterJsontable" element={<OperaterJsontable />} />
        <Route path="/MasterTabledetails" element={<MasterTableDetails />} />
        <Route path="/OperatorTabledetails" element={<OperatorTableDetails />} />
        <Route path="/ValidationRulesTabledetails" element={<ValidationRulesTableDetails />} />
        <Route path="/Reviewtable" element={<Reviewtable />} />
        <Route path="/Demadmin" element={<Demadmin />} />
        <Route path="/DEMupload" element={<DEMupload />} />
        <Route path="/BDMAdminUpload" element={<BDMAdminUpload />} />
        <Route path="/DemAdminTabledetails" element={<DemAdminTabledetails />} />
        <Route path="/DemRetrieve" element={<DemRetrieve />} />
        <Route path="/Templateform" element={<Templateform />} />
        <Route path="/DEMchecker" element={<DEMchecker />} />
        <Route path="/DEMcheckertablelist" element={<DEMcheckertablelist />} />
        <Route path="/DEMcheckertable" element={<DEMcheckertable />} />
        <Route path="/MasterRDM" element={<MasterRDM />} />
        <Route path="/OperatorsRDM" element={<OperatorsRDM />} />
        <Route path="/ValidationRulesRDM" element={<ValidationRulesRDM />} />
        <Route path="/FunctionsStackRDM" element={<FunctionsStackRDM />} />
        <Route path="/Templateformlist" element={<Templateformlist />} />
        <Route path="/Templateformmodifylist" element={<Templateformmodifylist />} />
        <Route path="/Edittemplateform" element={<Edittemplateform />} />
        <Route path="/Templatetablelist" element={<Templatetablelist />} />
        <Route path="/DemAdminRetrieve" element={<DemAdminRetrieve />} />
        <Route path="/DemcheckerRTL" element={<DemcheckerRTL />} />
        <Route path="/Demcheckertemplate" element={<Demcheckertemplate />} />
        <Route path="/MastercheckerRDM" element={<MastercheckerRDM />} />
        <Route path="/OperatorcheckerRDM" element={<OperatorcheckerRDM />} />
        <Route path="/ValidationRulesCheckerRDM" element={<ValidationRulesCheckerRDM />} />
        <Route path="/Bdmadmin" element={<Bdmadmin />} />
        <Route path="/BDMupload" element={<BDMupload />} />
        <Route path="/BdmAdminTabledetails" element={<BdmAdminTabledetails />} />
        <Route path="/BdmAdminRetrieve" element={<BdmAdminRetrieve />} />
        <Route path="/DemRetrieveTabledetails" element={<DemRetrieveTabledetails />} />
        <Route path="/BdmRetrieve" element={<BdmRetrieve />} />
        <Route path="/BdmRetrieveTabledetails" element={<BdmRetrieveTabledetails />} />
        <Route path="/BDMchecker" element={<BDMchecker />} />
        <Route path="/BdmcheckerRTL" element={<BdmcheckerRTL />} />
        <Route path="/Bdmcheckertemplate" element={<Bdmcheckertemplate />} />
        <Route path="/BdmcheckerTable" element={<BdmcheckerTable />} />
        <Route path="/BDMcheckertablelist" element={<BDMcheckertablelist />} />
        <Route path="/Bulkupload" element={<Bulkupload />} />
        <Route path="/BDMuploadTabledetails" element={<BDMuploadTabledetails />} />
        <Route path="/Mastermodify" element={<Mastermodify />} />
        <Route path="/MastermodifyRDM" element={<MastermodifyRDM />} />
        <Route path="/MasterModifyTableDetail" element={<MasterModifyTableDetail />} />
        <Route path="/BdmPreview" element={<BdmPreview />} />
        <Route path="/DemPreview" element={<DemPreview />} />
        <Route path="/QuickEntryOcr" element={<QuickEntryOcr />} />
        <Route path="/TemplateformlistOcrUpload" element={<TemplateformlistOcrUpload />} />
        <Route path="/Bulkmodify" element={<Bulkmodify />} />
        <Route path="/BulkmodifyBDM" element={<BulkmodifyBDM />} />
        <Route path="/BulkModifyTableDetail" element={<BulkModifyTableDetail />} />
        <Route path="/BDMRetrieveModifytabledata" element={<BDMRetrieveModifytabledata />} />
        <Route path="/AccessUser" element={<AccessUser />} />
        <Route path="/AccessHierarchy" element={<AccessHierarchy />} />
        <Route path="/BulkupdateModifyRetrieve" element={<BulkupdateModifyRetrieve />} />

        <Route path="/RDMmasterbkp" element={<RDMmasterbkp />} />
        <Route path="/DEMBDMTemplatebkp" element={<DEMBDMTemplatebkp />} />
        <Route path="/RDMbkptablelist" element={<RDMbkptablelist />} />

        <Route path="/DEMModifytemplate" element={<DEMModifytemplate />} />
        <Route path="/DemTemplatePreview" element={<DemTemplatePreview />} />
        <Route path="/DemAdminTemplatModify" element={<DemAdminTemplatModify />} />

        <Route path="/DemCheckerRetrieve" element={<DemCheckerRetrieve />} />
        <Route path="/DemRetrievecheckerTabledetails" element={<DemRetrievecheckerTabledetails />} />
        <Route path="/DemRetrievechecker" element={<DemRetrievechecker />} />
        <Route path="/BackupList" element={<BackupList />} />
        <Route path="/DemMakerRetrieve" element={<DemMakerRetrieve />} />
        <Route path="/DemRetrievemakerTabledetails" element={<DemRetrievemakerTabledetails />} />
        <Route path="/DemMakerRetrieveModifyTableDetail" element={<DemMakerRetrieveModifyTableDetail />} />
        <Route path="/DEMModifyupload" element={<DEMModifyupload />} />
        <Route path="/DemRetrievecheckermodifyTabledetails" element={<DemRetrievecheckermodifyTabledetails />} />
        <Route path="/DEMRetrieveCheckermodify" element={<DEMRetrieveCheckermodify />} />
        <Route path="/DEMRetrieveModifytabledata" element={<DEMRetrieveModifytabledata />} />
        <Route path="/RDMAdminRetrieve" element={<RDMAdminRetrieve />} />
        <Route path="/RDMRetrieveTabledetails" element={<RDMRetrieveTabledetails />} />
        <Route path="/RDMRetrieve" element={<RDMRetrieve />} />
        <Route path="/RDMCheckerRetrieve" element={<RDMCheckerRetrieve />} />
        <Route path="/RDMRetrievecheckermodifyTabledetails" element={<RDMRetrievecheckermodifyTabledetails />} />
        <Route path="/RDMRetrievecheckerTabledetails" element={<RDMRetrievecheckerTabledetails />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/RDMRetrievechecker" element={<RDMRetrievechecker />} />
        <Route path="/RDMRetrieveCheckermodify" element={<RDMRetrieveCheckermodify />} />
        <Route path="/RDMRetrievemodifyTabledetails" element={<RDMRetrievemodifyTabledetails />} />
        <Route path="/RDMchangeRetrieveModifyTableDetail" element={<RDMchangeRetrieveModifyTableDetail />} />
        <Route path="/BDMRetrievechecker" element={<BDMRetrievechecker />} />
        <Route path="/BDMRetrievecheckerTabledetails" element={<BDMRetrievecheckerTabledetails />} />
        <Route path="/BDMRetrieveCheckermodify" element={<BDMRetrieveCheckermodify />} />
        <Route path="/BDMRetrievecheckermodifyTabledetails" element={<BDMRetrievecheckermodifyTabledetails />} />
        <Route path="/BDMCheckerRetrieve" element={<BDMCheckerRetrieve />} />
        <Route path="/BDMMakerRetrieveModifyTableDetail" element={<BDMMakerRetrieveModifyTableDetail />} />
        <Route path="/BDMRetrievemakerTabledetails" element={<BDMRetrievemakerTabledetails />} />
        <Route path="/BDMMakerRetrieve" element={<BDMMakerRetrieve />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/link-reset-password" element={<LinkResetPassword />} />
        <Route path="/UserManagement" element={<UserManagement />} />
        <Route path="/AccessControls" element={<AccessControls />} />
        <Route path="/Mastermaker" element={<Mastermaker />} />
        <Route path="/MastermakerRDM" element={<MastermakerRDM />} />
        <Route path="/Operatorsmaker" element={<Operatorsmaker />} />
        <Route path="/OperatorsmakerRDM" element={<OperatorsmakerRDM />} />
        <Route path="/FunctionsStackmaker" element={<FunctionsStackmaker />} />
        <Route path="/FunctionsStackmakerRDM" element={<FunctionsStackmakerRDM />} />
        <Route path="/DEMUploadModifyTemplate" element={<DEMUploadModifyTemplate />} />
        <Route path="/Datalevel" element={<Datalevel />} />
        <Route path="/Auditlevel" element={<Auditlevel />} />
        <Route path="/Datalevelchecker" element={<Datalevelchecker />} />
        <Route path="/Datalevelchecker_test" element={<Datalevelchecker_test />} />

        <Route path="/BackupPreview" element={<BackupPreview />} />
        <Route path="/BdmMakerPreview" element={<BdmMakerPreview />} />
        <Route path="/RDMmastercheckerbkp" element={<RDMmastercheckerbkp />} />
        <Route path="/RDMbkpcheckertablelist" element={<RDMbkpcheckertablelist />} />
        <Route path="/BackupcheckerList" element={<BackupcheckerList />} />
        <Route path="/BackupcheckerPreview" element={<BackupcheckerPreview />} />
        <Route path="/DEMbkptablelist" element={<DEMbkptablelist />} />
        <Route path="/BDMbkptablelist" element={<BDMbkptablelist />} />
        <Route path="/DEMBDMtempcheckerbkp" element={<DEMBDMtempcheckerbkp />} />
        <Route path="/DEMbkpcheckertablelist" element={<DEMbkpcheckertablelist />} />
        <Route path="/BDMbkpcheckertablelist" element={<BDMbkpcheckertablelist />} />
        <Route path="/DEMBackupcheckerList" element={<DEMBackupcheckerList />} />
        <Route path="/BDMBackupcheckerList" element={<BDMBackupcheckerList />} />
        <Route path="/DEMBackupcheckerPreview" element={<DEMBackupcheckerPreview />} />
        <Route path="/BDMBackupcheckerPreview" element={<BDMBackupcheckerPreview />} />
        <Route path="/DemuploadAdmin" element={<DemuploadAdmin />} />
        <Route path="/AdminautoDEM" element={<AdminautoDEM />} />
        <Route path="/DEMautoTableDetails" element={<DEMautoTableDetails />} />
        <Route path="/BdmuploadautoAdmin" element={<BdmuploadautoAdmin />} />
        <Route path="/AdminautoBDM" element={<AdminautoBDM />} />
        <Route path="/AdminautoBDM" element={<AdminautoBDM />} />
        <Route path="/BDMModifytemplate" element={<BDMModifytemplate />} />
        <Route path="/BDMUploadModifyTemplate" element={<BDMUploadModifyTemplate />} />
        <Route path="/BdmAdminTemplatModify" element={<BdmAdminTemplatModify />} />
        <Route path="/BDMautoTableDetails" element={<BDMautoTableDetails />} />
        <Route path="/DEMBackupList" element={<DEMBackupList />} />
        <Route path="/BDMBackupList" element={<BDMBackupList />} />
        <Route path="/BDMBackupPreview" element={<BDMBackupPreview />} />
        <Route path="/DEMBackupPreview" element={<DEMBackupPreview />} />
        <Route path="/TemplateHierarchy" element={<TemplateHierarchy />} />
        <Route path="/DataHierarchy" element={<DataHierarchy />} />
        <Route path="/Form" element={<Form />} />
        <Route path="/Modify" element={<Modify />} />
        <Route path="/DemAdminRejectedTemplatModify" element={<DemAdminRejectedTemplatModify />} />
        <Route path="/DEMUploadModifyRejectedTemplate" element={<DEMUploadModifyRejectedTemplate />} />

        <Route path="/BdmAdminRejectedTemplatModify" element={<BdmAdminRejectedTemplatModify />} />
        <Route path="/BDMUploadRejectedModifyTemplate" element={<BDMUploadRejectedModifyTemplate />} />

        <Route path="/FunctionsStackchecker" element={<FunctionsStackchecker />} />
        <Route path="/FunctionsStackcheckerRDM" element={<FunctionsStackcheckerRDM />} />

        <Route path="/Datalevelcheckerrept" element={<Datalevelcheckerrept />} /> */}
          <Route path="/RejectedReason" element={<RejectedReason />} />
          {/* <Route path="/DataControls" element={<DataControls />} />
        <Route path="/Paginate" element={<Paginate />} />
        <Route path="/BDMDesignTemplate" element={<BDMDesignTemplate />} />
        <Route path="/BDMDesignRejectedTemplateModify" element={<BDMDesignRejectedTemplateModify />} />
        <Route path="/BDMDesignTableDetails" element={<BDMDesignTableDetails />} />
        <Route path="/DataTemplateControl" element={<DataTemplateControl />} />
        <Route path="/DEMDesignTableDetails" element={<DEMDesignTableDetails />} />
        <Route path="/DEMDesignExistingTableDetails" element={<DEMDesignExistingTableDetails />} />
        <Route path="/BDMDesignExistingTableDetails" element={<BDMDesignExistingTableDetails />} />
        <Route path="/DEMDesignTemplate" element={<DEMDesignTemplate />} />
        <Route path="/DEMDesignRejectedTemplateModify" element={<DEMDesignRejectedTemplateModify />} />
        <Route path="/Rdmcheckertablelist" element={<Rdmcheckertablelist />} /> */}
          <Route path="/Modalpopup" element={<Modalpopup />} />
          {/* <Route path="/OCRMethod" element={<OCRMethod />} />
        <Route path="/UserManagementTempupload" element={<UserManagementTempupload />} />
        <Route path="/UserManagementTempBDMupload" element={<UserManagementTempBDMupload />} />
        <Route path="/BDMOcrupload" element={<BDMOcrupload />} />
        <Route path="/FAQ" element={<FAQ />} /> */}
          <Route path="/Preview" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <Preview />
            </ProtectedRoute>
          } />
          {/* <Route path="/PreviewBDM" element={<PreviewBDM />} />
        <Route path="/Bulkupdate" element={<Bulkupdate />} />
        <Route path="/BulkOcrUpdate" element={<BulkOcrUpdate />} />
        <Route path="/EditRetrievalForm" element={<EditRetrievalForm />} />
        <Route path="/AuditReport" element={<AuditReport />} />
        <Route path="/BulkuploadOcrTabledetails" element={<BulkuploadOcrTabledetails />} /> */}
          {/* <Route path="/ChatbotContext " element={<ChatbotContext  />} /> */}
          <Route path="/ChatbotProvider " element={<ChatbotProvider />} />

          {/* <Route path="/AuditReportDetails" element={<AuditReportDetails />} />
        <Route path="/BulkupdateRetrieve" element={<BulkupdateRetrieve />} />
        <Route path="/AuditUserReportDetails" element={<AuditUserReportDetails />} />
        <Route path="/DEMcheckerRetrievetablelist" element={<DEMcheckerRetrievetablelist />} />
        <Route path="/DEMcheckerRetrievetable" element={<DEMcheckerRetrievetable />} />
        <Route path="/EditModifyRetrievalForm" element={<EditModifyRetrievalForm />} />
        <Route path="/storeFile" element={<storeFile />} /> */}
          {/* <Route path="/ReportDesign" element={<ReportDesign />} /> */}
          <Route path="/TemplateUpload" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <TemplateUpload />
            </ProtectedRoute>
          } />
          {/* <Route path="/Datalevelcomparison" element={<Datalevelcomparison />} />
        <Route path="/Datalevelcomparison1" element={<Datalevelcomparison1 />} />
        <Route path="/Dashboardreport" element={<Dashboardreport />} />
        <Route path="/Comaprisontablelist" element={<Comaprisontablelist />} />
        <Route path="/DashboardAuditTableDetails" element={<DashboardAuditTableDetails />} />
        <Route path="/DashboardAuditMakerActivityDetails" element={<DashboardAuditMakerActivityDetails />} /> */}

          {/* New page URL's */}
          {/* <Route path="/gapsyLogin" element={<GapsyLogin />} /> */}
          {/* <Route path="/gapsyHome" element={<GapsyHome />} /> */}
          {/* <Route path="/gapsyDashboardAdmin" element={
          <ProtectedRoute allowedRoles={['admin', 'superuser']}>
            <GapsyDashobardAdmin />
          </ProtectedRoute>
        } /> */}
          <Route path="/gapsyAdashboard" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyAdashboard />
            </ProtectedRoute>
          } />
          <Route path="/gapsyCdashboard" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyCdashboard />
            </ProtectedRoute>
          } />
          <Route path="/gapsyMdashboard" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMdashboard />
            </ProtectedRoute>
          } />
          <Route path="/gapsyFbc" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyFbc />
            </ProtectedRoute>
          } />
          <Route path="/gapsyMet" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyMet />
            </ProtectedRoute>
          } />
          <Route path="/GapsyBDMupload" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyBDMupload />
            </ProtectedRoute>
          } />
          <Route path="/SummaryReport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <SummaryReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyModifyupload" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyModifyupload />
            </ProtectedRoute>
          } />
          {/* <Route path="/GapsyTablelist" element={<GapsyTablelist />} /> */}
          <Route path="/GapsyIbm" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyIbm />
            </ProtectedRoute>
          } />
          <Route path="/GapsyUserRegistration" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyUserRegistration />
            </ProtectedRoute>
          } />
          <Route path="/GapsyUserMapping" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyUserMapping />
            </ProtectedRoute>
          } />
          <Route path="/GapsyUserConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyUserConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyUserModify" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyUserModify />
            </ProtectedRoute>
          } />
          <Route path="/GapsyUserRoleandMapping" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyUserRoleandMapping />
            </ProtectedRoute>
          } />
          <Route path="/GapsyParameterMapping" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyParameterMapping />
            </ProtectedRoute>
          } />
          <Route path="/GapsyAutomatedUpload" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyAutomatedUpload />
            </ProtectedRoute>
          } />
          <Route path="/GapsyIbmCreate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyIbmCreate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyTempAssign" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyTempAssign />
            </ProtectedRoute>
          } />
          <Route path="/GapsyReAssign" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyReAssign />
            </ProtectedRoute>
          } />
          <Route path="/gapsyMqem" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyQem />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariah" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariah />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualCreditRisk" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyResidualCreditRisk />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualModifyRisk" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyResidualModifyRisk />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahModify" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariahModify />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualModify" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyResidualModify />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahModifyRetrieval" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariahModifyRetrieval />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahPastRetrieval" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariahPastRetrieval />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahPastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyShariahPastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsPastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyComplaintsPastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaPastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyMediaPastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipPastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyLeadershipPastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyMediaOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyLeadershipOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyMediaOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyLeadershipOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahRajni" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariah1 />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyShariahList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerComplaintsList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerComplaintsList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerReportList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerReportList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerComplaint" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerComplaint />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerReport" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerMediaList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerMediaList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerLeadershipList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerLeadershipList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerMedia" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerMedia />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerLeadership" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerLeadership />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerModifyComplaint" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyComplaint />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerModifyReport" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerModifyMedia" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyMedia />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerModifyLeadership" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyLeadership />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRetrieveModifyComplaint" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyRetrieveModifyComplaint />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRetrieveModifyMedia" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyRetrieveModifyMedia />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRetrieveModifyLeadership" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyRetrieveModifyLeadership />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualCreditRiskList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyResidualCreditRiskList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyShariahListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyComplaintsListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyReportListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyReportListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyComplaintsReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyReportReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyReportReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyMediaListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyLeadershipListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyMediaReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyLeadershipReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintsReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyMediaReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyLeadershipReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyResidualReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyResidualListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahListReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahListReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualReinstateList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualReinstateList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyShariahReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahReviewRetrieval" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyShariahReviewRetrieval />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahConfiguration" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahConfiguration />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyShariahConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsConfiguration" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintsConfiguration />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintsConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsListConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintsListConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsWorkflowConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplaintsWorkflowConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyResidualListConfig" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyResidualListConfig />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyShariahReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintsReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyComplaintsReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyMediaReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyLeadershipReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyShariahAdmin" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyShariahAdmin />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaint" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyComplaint />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMedia" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyMedia />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadership" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyLeadership />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplaintList" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyComplaintList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMediaList" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyMediaList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyLeadershipList" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyLeadershipList />
            </ProtectedRoute>
          } />
          <Route path="/gapsyQeRejectData" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyQeRejectData />
            </ProtectedRoute>
          } />
          <Route path="/gapsyEditTemplateForm" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyEditTemplateForm />
            </ProtectedRoute>
          } />
          <Route path="/gapsyEditPastData" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyEditPastData />
            </ProtectedRoute>
          } />
          <Route path="/gapsyModifyPastData" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyModifyPastData />
            </ProtectedRoute>
          } />
          {/* <Route path="/GapsySamplePage" element={<GapsySamplePage />} /> */}
          <Route path="/Dropdown" element={<Dropdown />} />
          <Route path="/PopupTableModal" element={<PopupTableModal />} />
          {/* <Route path="/gapsyrdata" element={<GapsyRData />} /> */}
          <Route path="/gapsyrdata" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyRData />
            </ProtectedRoute>
          } />
          <Route path="/gapsyreport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyReport />
            </ProtectedRoute>
          } />
          <Route path="/gapsy-footer" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyFooter />
            </ProtectedRoute>
          } />
          <Route path="/GapsyDashboardReport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyDashboardReport />
            </ProtectedRoute>
          } />
          <Route path="/gapsycaudit" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyCaudit />
            </ProtectedRoute>
          } />
          <Route path="/gapsyQeApproveData" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyQeApproveData />
            </ProtectedRoute>
          } />
          <Route path="/NotFound" element={<NotFound />} />
          <Route path="/ProtectedRoute" element={<ProtectedRoute />} />
          <Route path="/gapsytrendreport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyTrendreport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRiskAppetiteReport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyRiskAppetiteReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalPastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyOperationalPastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyOperationalOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyOperationalOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerOperationalList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerOperationalList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerOperational" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerOperational />
            </ProtectedRoute>
          } />

          <Route path="/GapsyMakerModifyOperational" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyOperational />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRetrieveModifyOperational" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyRetrieveModifyOperational />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyOperationalListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyOperationalReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyOperationalReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyOperationalReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperational" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyOperational />
            </ProtectedRoute>
          } />
          <Route path="/GapsyOperationalList" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyOperationalList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyCompliancePastApprove" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyCompliancePastApprove />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceOverride" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplianceOverride />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceOverrideList" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplianceOverrideList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerComplianceList" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerComplianceList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyMakerCompliance" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerCompliance />
            </ProtectedRoute>
          } />

          <Route path="/GapsyMakerModifyCompliance" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyMakerModifyCompliance />
            </ProtectedRoute>
          } />
          <Route path="/GapsyRetrieveModifyCompliance" element={
            <ProtectedRoute allowedRoles={['maker', 'superuser']}>
              <GapsyRetrieveModifyCompliance />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceListReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyComplianceListReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceReview" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyComplianceReview />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceReinstate" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyComplianceReinstate />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceReport" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyComplianceReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyCompliance" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyCompliance />
            </ProtectedRoute>
          } />
          <Route path="/GapsyComplianceList" element={
            <ProtectedRoute allowedRoles={['Admin', 'superuser']}>
              <GapsyComplianceList />
            </ProtectedRoute>
          } />
          <Route path="/GapsyNewMapping" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyNewMapping />
            </ProtectedRoute>
          } />
          <Route path="/GapsyNewReport" element={
            <ProtectedRoute allowedRoles={['admin', 'superuser']}>
              <GapsyNewReport />
            </ProtectedRoute>
          } />
          <Route path="/GapsyCRODashboard" element={
            <ProtectedRoute allowedRoles={['checker', 'admin', 'maker', 'superuser']}>
              <GapsyCRODashboard />
            </ProtectedRoute>
          } />
          <Route path="/GapsyTableauReport" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <GapsyTableauReport />
            </ProtectedRoute>
          } />
          <Route path="/sidebar" element={
            <ProtectedRoute allowedRoles={['checker', 'superuser']}>
              <Sidebar />
            </ProtectedRoute>
          } />
          {/* <Route path="/Adashboard" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <GapsyAdashboard />
          </ProtectedRoute>
        } /> */}
        </Routes>
        {!hideChatbot && <Chatbot />}
      </SessionProvider>
      {/* </ChatbotProvider> */}
    </>
  );
}

function App() {

  return (
    <SessionProvider>
      <ChatbotProvider>

        <BrowserRouter>

          <AppContent />

        </BrowserRouter>

      </ChatbotProvider>
    </SessionProvider>
  );
}


export default App;